import { Component } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import {
  buildHandleBarModel,
  filterIfHandlebarNotRendered,
} from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { IconCacheService } from '@finxone-platform/shared/services';
import {
  BaseCssProperties,
  LogoutWidgetConfig,
  ProviderClass,
  baseCssConfigStyle,
  commonContentStyleList,
  commonTextContentStyleList,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-logout-widget',
  templateUrl: './logout-widget.component.html',
})
export class LogoutWidgetComponent extends BaseComponent {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public logoutWidgetData: {
    title: string;
    icon: string | undefined;
  } = {
    title: '',
    icon: undefined,
  };
  public textContentStyle: baseCssConfigStyle;
  public iconSize?: baseCssConfigStyle;
  public iconStyle?: baseCssConfigStyle;
  public globalStylingClass = '';
  public isAllowedGlobalStyling = false;

  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<LogoutWidgetConfig>,
    private store: Store,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
  ) {
    super();
    if (this.dataIn != undefined) {
      this.attri = this.dataIn.attri ?? null;
      if (this.attri != null) {
        this.logoutWidgetData.title = '';
        this.logoutWidgetData.icon = this.dataIn.attri?.widgetProperties?.icon ?? '';
        const template = Handlebars.compile(this.dataIn.attri?.widgetProperties?.textContent);

        buildHandleBarModel(
          this.store,
          this.logoutWidgetData.title,
          this.countriesCurrenciesService,
          this.iconCacheService,
        )
          .pipe(takeUntil(this.destroy$))
          .subscribe((model) => {
            this.logoutWidgetData.title = filterIfHandlebarNotRendered(template(model));
          });
      }
      this.getGlobalStyling();
    }

    this.iconStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.ICON_COLOR,
      BaseCssProperties.ICON_SIZE,
    ]);

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, commonContentStyleList);

    this.textContentStyle = this.configService.getSpecificBaseCssStyle(
      this.attri,
      commonTextContentStyleList,
    );

    this.iconSize = this.configService.getSpecificBaseCssStyle(this.attri, [BaseCssProperties.ICON_SIZE]);
  }

  private getGlobalStyling() {
    if (
      this.dataIn.attri?.widgetProperties?.['globalStylingClass'] &&
      this.dataIn.attri?.widgetProperties?.['globalStyling']
    ) {
      this.globalStylingClass = this.dataIn.attri?.widgetProperties?.['globalStylingClass'] ?? '';
      this.isAllowedGlobalStyling = this.dataIn.attri?.widgetProperties?.['globalStyling'] ?? false;
    }
  }
}
